// extracted by mini-css-extract-plugin
export default {"options":"Options_options__QCf3J","button":"Options_button__l7B9U","favorite":"Options_favorite__Io8qa"};